var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-table", {
    staticClass: "bordered",
    attrs: {
      "show-empty": "",
      responsive: "",
      striped: "",
      small: "",
      "empty-text": _vm.$t(
        "Nenhuma loja com entrega automática ou vendas no período."
      ),
      fields: _vm.fields,
      items: _vm.stores,
      "primary-key": "storeId",
      "tbody-tr-class": _vm.rowClass,
    },
    scopedSlots: _vm._u([
      {
        key: "cell(name)",
        fn: function (ref) {
          var item = ref.item
          return [
            _c(
              "b-link",
              {
                attrs: {
                  id: "auto-delivery-monitor_store-" + item.storeId,
                  title: _vm.$t("Filtrar o painel por esta loja"),
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("select-store", item.storeId)
                  },
                },
              },
              [_vm._v(" " + _vm._s(item.name || "#" + item.storeId) + " ")]
            ),
          ]
        },
      },
      {
        key: "cell(configuration)",
        fn: function (ref) {
          var item = ref.item
          return [
            _c(
              "b-badge",
              {
                staticClass: "mr-25",
                attrs: {
                  variant: item.autoDeliveryEnabled ? "success" : "secondary",
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      item.autoDeliveryEnabled
                        ? _vm.$t("Automático ligado")
                        : _vm.$t("Automático desligado")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "b-badge",
              {
                staticClass: "mr-25",
                attrs: {
                  variant: item.motoboyEnabled ? "light-primary" : "secondary",
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      item.motoboyEnabled
                        ? _vm.$t("Motoboys ligado")
                        : _vm.$t("Motoboys desligado")
                    ) +
                    " "
                ),
              ]
            ),
            _c(
              "b-badge",
              {
                attrs: {
                  variant: _vm.hasSupplierGap(item)
                    ? "danger"
                    : "light-primary",
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(item.activeDeliverySuppliers) +
                    " " +
                    _vm._s(_vm.$t("fornecedor(es) ativo(s)")) +
                    " "
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "cell(salesWithAlerts)",
        fn: function (ref) {
          var item = ref.item
          return [
            _c(
              "b-badge",
              {
                attrs: {
                  variant: item.salesWithAlerts ? "danger" : "light-success",
                },
              },
              [_vm._v(" " + _vm._s(item.salesWithAlerts) + " ")]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }